"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toPath;
var _underscore = _interopRequireDefault(require("./underscore.js"));
require("./toPath.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Internal wrapper for `_.toPath` to enable minification.
// Similar to `cb` for `_.iteratee`.
function toPath(path) {
  return _underscore.default.toPath(path);
}